export const POWERBI_EXPORT_STATUSES = {
  FAILED: 'Failed',
  NOT_STARTED: 'NotStarted',
  RUNNING: 'Running',
  SUCCEEDED: 'Succeeded',
  UNDEFINED: 'Undefined'
}
